import { globalConstants } from '../constants'

const init = {
	loading: true,
	items: [],
}

export function banks(state = init, action) {
	switch (action.type) {
		case globalConstants.GET_BANK_REQUEST:
			return {
				...state,
				loading: true,
			}
		case globalConstants.GET_BANK_SUCCESS:
			return {
				...state,
				items: action.banks,
				loading: false,
			}
		case globalConstants.GET_BANK_FAILURE:
			return {
				...state,
				error: action.error,
				loading: false,
			}

		default:
			return state
	}
}

export function search_customer(state = init, action) {
	switch (action.type) {
		case globalConstants.GET_SEARCH_CUSTOMER_REQUEST:
			return {
				...state,
				loading: true,
			}
		case globalConstants.GET_SEARCH_CUSTOMER_SUCCESS:
			return {
				...state,
				items: action.search_customer,
				loading: false,
			}
		case globalConstants.GET_SEARCH_CUSTOMER_FAILURE:
			return {
				...state,
				error: action.error,
				loading: false,
			}

		default:
			return state
	}
}

export function user_yaa_profile(state = { loading: true, item: { profile: {}, licenseHistory: [] } }, action) {
	switch (action.type) {
		case globalConstants.GET_USER_YAA_BY_ID_REQUEST:
			return {
				...state,
				loading: true,
			}
		case globalConstants.GET_USER_YAA_BY_ID_SUCCESS:
			return {
				...state,
				loading: false,
				item: action.user_yaa_profile,
			}
		case globalConstants.GET_USER_YAA_BY_ID_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			}

		default:
			return state
	}
}
